/*
   文件说明：
      该文件封装了axios，可以更方便地为请求添加token
*/
import axios from 'axios'
import requestConst from '@/api/util/request-const'
import CryptoJS from 'crypto-js'

import {
	Message
} from 'element-ui'

// create an axios instance
const service = axios.create({
	timeout: 60000 // request timeout
})

// request interceptor
service.interceptors.request.use(
	config => {
		let token = sessionStorage.getItem('token')
		// do something before request is sent
		config.headers['X-CSRF-TOKEN'] = token
		config.headers['Accept'] = 'application/json; charset=utf-8'
		config.headers['TICKET'] = sessionStorage.getItem("ticket")
		config.headers['USER'] = CryptoJS.MD5(sessionStorage.getItem("customData"))
		return config
	},
	error => {
		// do something with request error
		console.error(error) // for debug
		return Promise.reject(error)
	}
)
// response interceptor
service.interceptors.response.use(
	/**
	 * If you want to get http information such as headers or status
	 * Please return  response => response
	 */

	/**
	 * Determine the request status by custom code
	 * Here is just an example
	 * You can also judge the status by HTTP Status Code
	 */
	response => {
		const res = response.data
		//没有返回体
		if (!res) {
			console.debug('返回值错误')
			Message({
				message: '返回值错误',
				type: 'error',
				duration: 5 * 1000
			})
			return;
		}
		//200 状态时 如果返回的body的status!=0 也是失败
		/*if (!(res.status == requestConst.body.SUCCESS|| res.code == requestConst.body.SUCCESS)) {
			let msg=res.msg ? res.msg : "出现错误";
			return Promise.reject( {
				config:response.config,
				isAxiosError:true,
				request:response.request,
				response:response
			})
		}*/
		return res
	},
	error => {
		//响应
		const res = error.response;
		//响应状态码
		const status = res.status;
		//响应体
		const body = res.data;
		//没有登录
		if (status === requestConst.http.UNAUTHORIZED) {
			console.error('没有登录');
			//跳到登录页
			 return Promise.reject(error)
		}
		//没有响应体
		if (!body) {
			console.log('返回值错误')
			Message({
				message: ' 返回值错误' + status,
				type: 'error',
				duration: 5 * 1000
			})
			return Promise.reject(error);
		}
		//响应体状态
		const bodystatus = body.status;
		if (bodystatus === requestConst.body.UNAUTHENTICATION) {
			console.log('没有登录');
			//跳到登录页
		} else if (bodystatus === requestConst.body.CHART_REQUIRED) {

			console.log('还没选岗位');
			//跳到选岗位

		}
		return Promise.reject(error)
	}
)
export default service
